/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/anchor-has-content */
import React, { useRef, useState } from "react";
import CloseIcon from '@material-ui/icons/Close';
import { toAbsoluteUrl } from "../../_metronic/utils/utils";
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import { getOrderDetails,updateOrder,USDFormat} from "../crud/auth.crud";
import { Table } from "react-bootstrap";
import Alert from '@material-ui/lab/Alert'
import { Tooltip } from "@material-ui/core";
import {  format } from 'date-fns'

 import TextField from '@material-ui/core/TextField';

import CircularProgress from '@material-ui/core/CircularProgress';

import { makeStyles } from '@material-ui/core/styles';
import { parse } from "date-fns";

const useStyles = makeStyles({
  customNumberField: {
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type="number"]': {
      '-moz-appearance': 'textfield',
    },
  },
});

export default function EditOrderInvoice({onUpdate,onClose,order}) {
const classes = useStyles();
  

 const [quantity,setQuantity] = useState([]);
 const [discount,setDiscount] = useState([]);
 const [selectedAttributes,setSelectedAttributes] = useState([]);
 const [orderDetails,setOrderDetails] = useState([]);
 const [loading,setLoading] = useState(false);
 const [total,setTotal] = useState(false);
 const [status,setStatus] = useState({flag:false,validation:false, statusColor:'',statusMessage:'',loading:false});
 


 React.useEffect(() => {
          const fetch = async () => {
              try {
               setLoading(true);
 
                 let details = [];
                  const response = await getOrderDetails(order.id);
                  details = response.data;
               
                console.log("final:::",details);
                //setIntervalz(parseInt(intervalz));
               
                let total= 0.0;
                details.map((sr)=>{
                   total = parseFloat(total) + (parseFloat(sr.amount) * parseFloat(sr.quantity));
                   sr.subTotal=parseFloat(sr.quantity) * parseFloat(sr.product.price);
                   sr.discount=0;
                   sr.finalQuantity=sr.quantity;
                   sr.totalPrice = parseFloat(sr.quantity) * parseFloat(sr.product.price);
                })
                setOrderDetails(details);
                setTotal(total.toFixed(2));
                setLoading(false);
  
              } catch (e) {
                  console.log(e);
                  setLoading(false);
                  
              }
          };
          fetch();
      }, []);


  
 const handleQuantityChange=(e,od)=>{
  try{

  
    //console.log("handle chnage ::::",e);
    //console.log("handle chnage ::::",od,e.target.value);
    if(e!==null && e!==undefined && e.target!==null && e.target!==undefined && e.target.value!==null)
    {
      
       let qty = e.target.value;
      if(e.target.value==="")  qty=0;

      const newItem = { ['quantity_'+od.productKey]:qty};
      setQuantity(oldValues=> [...oldValues, newItem]);
       
      let cost = parseFloat(od.product.price) * parseFloat(qty);
      let  totalPrice = parseFloat(cost) - ((parseFloat(cost) * parseFloat(od.discount))/100)
      //console.log(cost);
      //this.setState({[`summary_${summary.productKey}`]:e.target.value});
      let alllist = orderDetails;
      let productIndex = alllist.findIndex(el => el.productKey == od.productKey);
      alllist[productIndex] = {...alllist[productIndex], subTotal: cost, totalPrice:totalPrice,finalQuantity:parseInt(qty)};
      setOrderDetails(alllist);
      //console.log("quantity::::",quantity);
      let total = 0;
      alllist.map((a)=>{
          total = parseFloat(total) + parseFloat(a.totalPrice);
      })
      setTotal(total.toFixed(2));
    }
    }
    catch(exception)
    {

    }

  }

   const handleDiscountChange=(e,od)=>{
   try{

  
    //console.log("handle chnage ::::",e);
    //console.log("handle chnage ::::",od,e.target.value);
    if(e!==null && e!==undefined && e.target!==null && e.target!==undefined && e.target.value!==null)
    {

      let discount = e.target.value;
      if(e.target.value==="")  discount=0;
      
      const newItem = { ['discount_'+od.productKey]:discount};
      setDiscount(oldValues=> [...oldValues, newItem]);
       
      //let cost = parseFloat(od.product.price) * parseFloat(od.finalQuantity);
      let  totalPrice = parseFloat(od.subTotal) - ((parseFloat(od.subTotal) * parseFloat(discount))/100)
      //console.log(cost);
      //this.setState({[`summary_${summary.productKey}`]:e.target.value});
      let alllist = orderDetails;
      let productIndex = alllist.findIndex(el => el.productKey == od.productKey);
      alllist[productIndex] = {...alllist[productIndex], totalPrice:totalPrice,discount:parseFloat(discount)};
      setOrderDetails(alllist);
      //console.log("quantity::::",quantity);
      let total = 0;
      alllist.map((a)=>{
          total = parseFloat(total) + parseFloat(a.totalPrice);
      })
      setTotal(total.toFixed(2));
    }
    }
    catch(exception)
    {

    }

  }

  const orderUpdate = () => {
    //this.setState({selectedDate : date});

    setStatus({flag:true,statusColor:'green',statusMessage:'Updating order. Please wait.',loading:true});

    let falseCount = false;
    orderDetails.map((ds)=>{
      if(ds.finalQuantity===null || ds.finalQuantity===undefined || ds.finalQuantity==="")
        falseCount = true;
      if(ds.finalQuantity!==null && ds.finalQuantity!=="" && isNaN(parseFloat(ds.finalQuantity)))
        falseCount = true;
      if(ds.finalQuantity!==null && ds.finalQuantity!=="" && !isNaN(parseFloat(ds.finalQuantity)) &&  parseFloat(ds.finalQuantity) < 0)
        falseCount = true;
      if(ds.discount!==null && ds.discount!=="" && isNaN(parseFloat(ds.discount)))
        falseCount = true;
      if(ds.discount!==null && ds.discount!=="" && !isNaN(parseFloat(ds.discount)) &&  (parseFloat(ds.discount) < 0 || parseFloat(ds.discount)>100))
        falseCount = true;

    })

    console.log("update order::::",orderDetails);

    let finalDetail = [];

    if(falseCount)
    {
      console.log("validation ::::missing");
      setStatus({flag:false,validation:true, statusColor:'error',statusMessage:'Validation error. Correct the error in Required Qty, discount and try again',loading:false});
      
    }
    else
    {
      updateOrder(order.id, orderDetails)
        .then(resp => {
          //console.log("add",resp);
          setStatus({flag:true,statusColor:'success',statusMessage:'Order Updated and Invoice has been generated succesfully',loading:false});

          //this.setState({shareStatus:true})
          onUpdate()
        })
    }

  }
  

  return (
    <>
      <div className="kt-portlet kt-portlet--height-fluid">
        <div className="kt-portlet__head">
          <div className="kt-portlet__head-label">
            <h3 className="kt-portlet__head-title">{'ORDER UPDATE (#'+order.orderKey+')'}</h3>
          </div>
          <div className="kt-portlet__head-toolbar">
            <a href="#" onClick={onClose}><CloseIcon style={{ color: '#5867dd',fontSize: 25}} /> </a>
          </div>
        </div>
        <div className="kt-portlet__body">
        
					<div className="kt-widget kt-widget--user-profile-3">
						<div className="kt-widget__top">
  							<div className="kt-widget__content">
											<div className="kt-widget__subhead">
														<Tooltip title="Ordered By"><a href='#' ><i className="flaticon2-calendar-3"></i>{order.accountName}</a></Tooltip>
														<Tooltip title="Order Date"><a href='#' ><i className="flaticon2-calendar-6"></i>{format(new Date(order.createdOn), 'MM/dd/yyyy')} </a></Tooltip>
														<Tooltip title="Requested User"><a href='#' ><i className="flaticon2-user-1"></i>{order.requestedBy} </a></Tooltip>
											</div>
									</div>
						</div>
					</div>
					
			
		
          {orderDetails!==null && orderDetails.length>0 &&
          <Table striped bordered hover>
                  <thead>
                    <tr>
                      
                      <th className="align-top">Item#</th>
                      <th className="align-top">Description</th>
                      <th className="align-top">Price</th>
                      <th className="align-top">Required Qty</th>
                      <th className="align-top">Approved Qty</th>
                      <th className="align-top">Sub Total</th>
                      <th className="align-top">Discount %</th>
                      <th className="align-top">Total Cost</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                  {orderDetails.map((od) => (
                    <tr className="align-items-center" key={od.id} style={{fontSize:14}} >
                     
                      <td className="align-middle">{od.product.productCode}</td>
                      <td className="align-middle">{od.product.productName}</td>
                  
                      <td className="align-middle" style={{color:'green',fontWeight:'bold'}}> {USDFormat(od.product.price)}</td>
                      
                      <td className="align-middle">{od.quantity}</td>
                      <td className="align-middle"><TextField
                              margin="normal"
                              className={classes.customNumberField}
                              type={'number'}
                              name={'qty_'+od.productKey}                                                     
                              onChange={(e)=>handleQuantityChange(e,od)}
                              //value={quantity[od.productKey]}     
                              variant="outlined" 
                                                  
                          /></td>
                       <td className="align-middle" style={{color:'green',fontWeight:'bold'}}>{od.subTotal!==null && od.subTotal!==undefined && USDFormat(od.subTotal)}</td>
                       <td className="align-middle"><TextField
                              margin="normal"
                              className={classes.customNumberField}
                              type={'number'}
                              name={'discount_'+od.productKey}                                                     
                              onChange={(e)=>handleDiscountChange(e,od)}
                              variant="outlined" 
                                                 
                          /></td>
                          <td className="align-middle" style={{color:'green',fontWeight:'bold'}}>{od.totalPrice!==null && od.totalPrice!==undefined && USDFormat(od.totalPrice)}</td>
                    </tr>
                    ))}
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="text-right" style={{color:'black',fontWeight:'bold'}}>Total</td>
                      <td className="align-middle" style={{color:'green',fontWeight:'bold'}}>{USDFormat(total)}</td>
                    </tr>
                </tbody>
                </Table>
          }
          {loading &&
          <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                      <Alert severity="info" icon={loading && <CircularProgress size={15} />}>&nbsp;&nbsp;{'Loading please wait...'}</Alert>      
                  </div>
          }
        </div>
        <div className="kt-portlet__foot">
        {!status.flag && (
            <Button
                variant="outlined"
                color="primary"
                endIcon={<Icon>send</Icon>}
                onClick={orderUpdate}
                style={{'margin':'5px'}}
                >
                Update Order
              </Button>
        )}
              {status.flag && (
                <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                      <Alert severity={status.statusColor} icon={status.loading && <CircularProgress size={15} />}>&nbsp;&nbsp;{status.statusMessage}</Alert>      
                  </div>
                      )}

                      {status.validation && (
                <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                      <Alert severity={status.statusColor} icon={status.loading && <CircularProgress size={15} />}>&nbsp;&nbsp;{status.statusMessage}</Alert>      
                  </div>
                      )}
				
          </div>
      </div>
    </>
  );
}
